import { render, staticRenderFns } from "./FaceZoneSelectionPicture.vue?vue&type=template&id=36480c9a&scoped=true"
import script from "./FaceZoneSelectionPicture.vue?vue&type=script&lang=js"
export * from "./FaceZoneSelectionPicture.vue?vue&type=script&lang=js"
import style0 from "./FaceZoneSelectionPicture.vue?vue&type=style&index=0&id=36480c9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36480c9a",
  null
  
)

export default component.exports